import React, { useState, useEffect } from "react";
import API from "../services";
import "swiper/css";
import 'swiper/css/pagination';
import {useLocation, useNavigate } from "react-router-dom";
import "./SportsPage.scss"
import { RootState } from "../models/RootState";
import { connect } from "react-redux";
import { setLobby, setSportsExchData, setSportsSBData } from "../store/authReducer";
// import Loader from "../assets/images/Strike_White_Logo_Transparent_GIF.gif";
import { getGameUrl } from "../store/authActions";
import ClassicExchEvents from "./ClassicExchEvents/ClassicExchEvents";
import ClassicSBEvents from "./ClassicSBEvents/ClassicSBEvents";
import { Loader } from "../constants/whitelabelEnv";
import { domain } from "../constants/Branding";
import { UserDetails } from "../models/UserDetails";


interface SportsPageProps {
  sportsExchData: any;
  setSportsExchData: (data: any) => void;
  exchAuthData: any;
  sportsSBData: any;
  setSportsSBData: (data: any) => void;
  sbAuthData: any;
  getGameUrl: (provider: any) => void;
  setLobby: (data: any) => void;
  lobby: string;
  userDetails: UserDetails;
  // classic: boolean;
  // setSportView: (value: boolean) => void;
}

const SportsPage: React.FC<SportsPageProps> = ({ sportsExchData, setSportsExchData, exchAuthData, sportsSBData, setSportsSBData, sbAuthData, getGameUrl, setLobby, lobby, userDetails }) => {
  const navigate = useNavigate();
  const location = useLocation();
  // const [gameSrc, setGameSrc] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [gameData, setGameData] = useState<any>();

  // Set lobby based on URL path
  useEffect(() => {
    if (location.pathname.includes('exchange')) {
      setLobby('EXCHANGE');
    } else if (location.pathname.includes('sportsbook')) {
      setLobby('SPORTSBOOK');
    }
  }, [location.pathname, setLobby]);

  // const getSportsInfo = async (lobby: string) => {
  //   setLoading(true);
  //   let response;
  //   try {
  //     response = await API.post(`/webapp/get-sports-content`, {
  //       lobby: lobby
  //     });
  //   } catch (e) {
  //     console.log(e);
  //     setLoading(false);
  //     return;
  //   }

  //   if (response.data.status !== "RS_OK") {
  //     navigate("/home");
  //   }

  //   if (response && response.data.sections) {
  //     setGameData(response.data?.sections);
  //     if (lobby == "EXCHANGE") {
  //       setSportsExchData(response?.data?.sections);
  //     } else {
  //       setSportsSBData(response?.data?.sections);
  //     }
  //   }

  //   setLoading(false);
  // };

  // useEffect(() => {
  //   // if (sportsData && sportsData.length > 0) {
  //   //   setGameData(sportsData);
  //   // } else {
  //   //   getSportsInfo();
  //   // }
  //   // getGameUrl();
  //   getSportsData(lobby);
  // }, [lobby])

  // const getSportsData = (provider: string) => {
  //   setLobby(provider);
  //   if (classic) {
  //     return;
  //   }
  //   // setProviderTab(provider);
  //   if (provider === "EXCHANGE") {
  //     if (!(exchAuthData && exchAuthData?.token)) {
  //       // getGameUrl("EX123");
  //     }
  //     if (sportsExchData && sportsExchData.length > 0) {
  //       setGameData(sportsExchData);
  //     } else {
  //       getSportsInfo(provider);
  //     }
  //   } else {
  //     if (!(sbAuthData && sbAuthData?.token)) {
  //       // getGameUrl("SB123");
  //     }
  //     if (sportsSBData && sportsSBData.length > 0) {
  //       setGameData(sportsSBData);
  //     } else {
  //       getSportsInfo(provider);
  //     }

  //   }
  // }


  const handleFavoriteClick = async (game: any) => {
    setGameData((prevGameData: any) =>
      prevGameData?.map((section: any) => ({
        ...section,
        items: section?.items?.map((gameMap: any) =>
          gameMap?.id === game?.id
            ? { ...gameMap, isFavorite: !gameMap?.isFavorite }
            : gameMap
        ),
      }))
    );
    let response;
    try {
      // Make the API call to update the favorite status
      response = await API.post('/webapp/set-favorite', {
        category: game.category,
        id: game.id,
        isFavorite: !game.isFavorite,
        name: game?.name,
        provider: game?.provider,
        subProvider: game.subProvider,
        thumbnail: game.thumbnail,
        type: game.type,
        tgProviderId: game?.tgProviderId,
        tableId: game?.tableId,
        userKey: sessionStorage.getItem("userKey")
      });

    } catch (error) {
      console.error('Error updating favorite status:', error);
      // Revert the state change if the API call fails
    }

    if (response && response.data?.status === "RS_OK") {
      const updatedGameData = gameData?.map((section: any) => ({
        ...section,
        items: section?.items?.map((gameMap: any) =>
          gameMap?.id === game?.id
            ? { ...gameMap, isFavorite: !gameMap?.isFavorite }
            : gameMap
        ),
      }));
      setSportsExchData(updatedGameData);
    }
  };

  // const handleToggleChange = (e: any) => {
  //   setSportView(e.target.checked);
  //   setUserSportsView(e.target.checked);
  // };


  return (
    <div className="flex flex-col px-3 mt-4 w-full pb-[7rem] py-[4rem] casino">
      {
        loading ? (
          <div className="home-loading">
            <img src={Loader(domain)} style={{ height: '10rem' }} />
          </div>
        ) : (
          <>
            {
            // classic ? (
              lobby === "EXCHANGE" && userDetails?.exchangeProvider ? (
                <ClassicExchEvents />
              ) : userDetails?.sportsbookProvider ? (
                <ClassicSBEvents />
              ) : (
                <></>
              )
            // ) :
            //   <div className="main-section">
            //     {gameData?.map((section: any, index: number) => (
            //       <div key={index} style={{ marginBottom: '10px' }}>
            //         <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '0.75rem' }}>
            //           <div>
            //             <img src={section?.sectionIcon !== "" ? section?.sectionIcon : `${S3_IMG}/casino.svg`} alt={section?.sectionTitle} style={{ width: '1rem', marginRight: '5px' }} />
            //           </div>
            //           <span className="section-title">{section.sectionTitle}</span>
            //         </div>
            //         <Swiper
            //           spaceBetween={10}
            //           slidesPerView={2.1}
            //           breakpoints={{
            //             640: { slidesPerView: 3.5, spaceBetween: 10 },
            //             768: { slidesPerView: 3.5, spaceBetween: 20 },
            //             1024: { slidesPerView: 4, spaceBetween: 30 },
            //           }}
            //         >
            //           {section?.items.map((game: any, gameIndex: number) => (
            //             <SwiperSlide key={game?.id + gameIndex}>
            //               <div style={{}}>
            //                 <NavLink
            //                   to={
            //                     (game.type.toLowerCase() === "sport" || game.type.toLowerCase() === "competition")
            //                       ? `/events/${btoa(`${game?.id}#${game?.name}#${game?.provider}#${game?.type}`)}` :
            //                       game?.provider == "SPORTSBOOK" ?
            //                         `/sb-markets/${btoa(`${game?.id}`)}`
            //                         : `/markets/${btoa(`${game?.id}`)}`
            //                   }
            //                   className={`nav-link`}
            //                 >
            //                   <div className="game-img relative" style={{ marginBottom: '0.5rem', height: '7.5rem', width: '10rem' }}>
            //                     <img src={game?.thumbnail} alt={game?.gameName} style={{ width: '100%', height: '100%', borderRadius: '12px' }} />
            //                     <div style={{ position: 'absolute', top: '5px', right: '5px' }}>
            //                       {game?.isFavorite ? <FavoriteOutlined
            //                         className="gold-favourite-img"
            //                         titleAccess={"remove from favourites"}
            //                         onClick={(e) => {
            //                           e.preventDefault();
            //                           handleFavoriteClick(game);
            //                         }}
            //                       /> : <FavoriteBorderOutlined
            //                         className="red-favourite-img"
            //                         titleAccess={"remove from favourites"}
            //                         onClick={(e) => {
            //                           e.preventDefault();
            //                           handleFavoriteClick(game);
            //                         }}
            //                       />}
            //                     </div>
            //                   </div>
            //                 </NavLink>
            //                 <div className="game-name">{game?.name}</div>
            //                 <div className="prov-name">{game?.provider}</div>
            //               </div>
            //             </SwiperSlide>
            //           ))}
            //         </Swiper>
            //       </div>
            //     ))}

            //   </div>
            }
          </>
        )
      }
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    sportsExchData: state.userDetails?.sportsExchData,
    exchAuthData: state.userDetails?.exchData,
    sportsSBData: state.userDetails?.sportSBData,
    sbAuthData: state.userDetails?.sbData,
    lobby: state.userDetails?.lobby,
    userDetails: state.userDetails?.userDetails,
    // classic: state.userDetails?.userDetails?.IsClassic,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setSportsExchData: (data: any) => {
      dispatch(setSportsExchData(data));
    },
    setSportsSBData: (data: any) => {
      dispatch(setSportsSBData(data));
    },
    getGameUrl: (provider: string) => {
      dispatch(getGameUrl(provider));
    },
    setLobby: (provider: string) => {
      dispatch(setLobby(provider));
    },
    // setSportView: (value: boolean) => {
    //   dispatch(setSportView(value));
    // },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SportsPage);
